module.exports = __webpack_public_path__ + "static/img/srhd_ic_warn @2x.06a6882.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/srhd_ic_warn @2x.png
// module id = NaMu
// module chunks = 1